import { MessageCircle } from "lucide-react"

export default function EmptyState() {
  return (
    <div className="flex flex-1 items-center justify-center p-4">
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        {/* Icon */}
        <div className="flex size-16 items-center justify-center rounded-full bg-slate-100 dark:bg-slate-800">
          <MessageCircle className="size-8 text-slate-400 dark:text-slate-500" />
        </div>

        {/* Heading */}
        <h2 className="text-2xl font-semibold text-slate-900 dark:text-white">
          Start a Conversation
        </h2>

        {/* Subtext */}
        <p className="max-w-sm text-base leading-relaxed text-slate-600 dark:text-slate-300">
          Type or tap the mic to begin. Switch languages anytime by tapping the
          flag below.
        </p>
      </div>
    </div>
  )
}
